import { inject } from '@angular/core';

import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';

import { UserService } from '@shared/services/user.service';

/**
 * Blocks navigation to protected `kt-layout` children until the signed-in teacher has a
 * teaching profile. Awaits the cached/single-flight `UserService.getMe()` before deciding.
 *
 * - `hasProfile=false` → redirects to `/` (home, the profile overlay host — option D).
 * - `hasProfile=true` → allows navigation.
 *
 * Wired onto the `guided-activity-wizard` route in `kt.routes.ts` (FE-4).
 *
 * @returns The result of this operation.
 */
export const profileGuard: CanActivateFn = async () => {
  const userService = inject(UserService);
  const router = inject(Router);

  await userService.getMe();

  if (userService.hasProfile()) {
    return true;
  }

  return router.createUrlTree(['/']);
};
